
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["uqdzed",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z","fill":"#BD081C","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M30 14c-8.836 0-16 7.171-16 16.017 0 6.592 3.98 12.254 9.665 14.713-.04-1.116-.001-2.448.281-3.655.31-1.303 2.069-8.76 2.069-8.76s-.514-1.027-.514-2.544c0-2.38 1.38-4.16 3.097-4.16 1.46 0 2.167 1.1 2.167 2.415 0 1.47-.937 3.667-1.42 5.702-.4 1.705.857 3.097 2.537 3.097 3.04 0 5.088-3.91 5.088-8.548 0-3.52-2.367-6.16-6.68-6.16-4.87 0-7.907 3.637-7.907 7.7 0 1.4.414 2.39 1.061 3.153.297.35.337.493.229.897-.078.294-.251 1.006-.325 1.29-.107.407-.438.55-.805.4-2.242-.915-3.289-3.374-3.289-6.139 0-4.567 3.848-10.042 11.477-10.042 6.132 0 10.166 4.442 10.166 9.207 0 6.309-3.503 11.017-8.664 11.017-1.734 0-3.366-.938-3.922-2.002 0 0-.935 3.7-1.13 4.418-.337 1.221-.987 2.441-1.588 3.402a16 16 0 004.407.615c8.836 0 16-7.171 16-16.016C46 21.17 38.836 14 30 14","fill":"#FFF"}})])])
          )
        }
      }
    